import { Tag } from '@ver-uds/react';
import { Alert } from '@ver-uds/uswds-react';
import React from 'react';
import AccessMethodAccordionCard from './AccessMethodAccordionCard';
import { AccessMethodType } from './AccessMethodFormData';

export default function CorporateCard(): JSX.Element {
  return (
    <AccessMethodAccordionCard
      id="corporate"
      label="Corporate Administrator"
      headerTag={<Tag variant="warning">Management Oversight Account</Tag>}
      value={AccessMethodType.CORPORATE}
      body={
        <>
          <p>
            Your company plans to link and manage multiple Employer accounts which share a common ownership structure or
            corporate control.
          </p>
          <Alert status="info" slim>
            Cases CANNOT be created, managed, or viewed using a Corporate Administrator account.
          </Alert>
          {/*
            The `.usa-card__body` styles that `<AccordionCard.MoreDetails>` inherits set the bottom padding of the
            last child to 0. This doesn't negative affect most elements, however, for elements that have a
            background applied (`<Alert>`, for example), this has a detrimental effect.
            As a workaround to prevent this behavior, we add an empty last child element.
          */}
          <div />
        </>
      }
      moreDetails={
        <>
          <p className="margin-top-3">This account access allows you to:</p>
          <ul>
            <li>
              Create and manage Employer accounts (company locations) for companies that are part of a common ownership
              structure or corporate control
            </li>
            <li>Manage company account information</li>
            <li>Add, edit, and delete Corporate Administrator users</li>
            <li>Add, edit, and delete users on linked Employer accounts (company locations)</li>
          </ul>
        </>
      }
    />
  );
}
